import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ReminderFlow from 'components/Flows/ReminderFlows/ReminderFlows';
import ReminderAnalysisDrawer from 'components/Analyses/ReminderAnalyses/Drawer/Drawer';

const ReminderFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ReminderAnalysisDrawer />
      <ReminderFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ReminderFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);